// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020843/js/" + chunkId + "." + {"44":"e9fc10af","225":"bfca8ed5","481":"85b45152","486":"4480aea5","770":"c52b73e2"}[chunkId] + ".0.8762768024791191.chunk.js";
};